<template>
  <div>
    <modal-detalhes
      :eleicao="eleicaoDetalhes"
      :key="updComponentes + 4"
      v-if="opendetalhes"
    ></modal-detalhes>
    <modal-abstencoes
      :eleicao="eleitoresAbstencao"
      :key="updComponentes + 4"
      v-if="openabstencoes"
    ></modal-abstencoes>
    <modal-zeresima
      :eleicao="eleicaoZeresima"
      :key="'z' + updComponentes"
      v-if="openzeresima"
    ></modal-zeresima>
    <modal-editar-eleicoes
      :eleicao="eleicaoEditar"
      v-on:refreshComponent="getAllEleicoes"
      :key="updComponentes"
    ></modal-editar-eleicoes>
    <modal-cadastrar-eleicoes
      v-on:refreshComponent="getAllEleicoes"
      :key="updComponentes + 1"
    ></modal-cadastrar-eleicoes>
    <modal-candidatos
      :key="updComponentes + 2"
      :eleicao="eleicaoDetalhes"
    ></modal-candidatos>
    <modal-usuarios-eleicao
      :eleicao="eleicaoDetalhes"
      :key="updComponentes + 3"
      v-if="openusuarioeleicao"
    ></modal-usuarios-eleicao>
    <modal-justificativa
      v-on:fetch="getAllEleicoes"
      :eleicao="eleicaojustificativa"
      :key="updComponentes + 5"
    ></modal-justificativa>
    <div>
      <h3 class="h3-responsive module-header">Gerenciar Eleições</h3>
    </div>
    <div class="card">
      <div class="card-body">
        <button
          id="modalActivate"
          type="button"
          class="btn btn-primary"
          data-toggle="modal"
          @click="newEleicao"
          data-target="#exampleModalPreview"
        >
          <i class="fa fa-plus"></i>&nbsp; Nova Eleição
        </button>
        <div class="table-responsive">
          <table class="table table-striped">
            <thead>
              <tr>
                <th>#</th>
                <th>Descrição</th>
                <th>Situação</th>
                <th>Data Inicial</th>
                <th>Data Final</th>
                <th>Ação</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="isLoading">
                <td colspan="6" class="text-center">
                  <Loading />
                </td>
              </tr>
              <tr v-if="eleicoes.length == 0 && !isLoading">
                <td colspan="6" class="text-center">
                  Nenhum registro encontrado
                </td>
              </tr>
              <tr v-for="(eleicao, index) in eleicoes" :key="index">
                <td>{{ ++index }}</td>
                <td>{{ eleicao.strdescricao }}</td>
                <td>
                  <span
                    v-html="$options.filters.situacao(eleicao.intsituacao)"
                  ></span>
                </td>
                <td>{{ eleicao.dtainicial | dateFull_br }}</td>
                <td>{{ eleicao.dtafinal | dateFull_br }}</td>

                <td>
                  <a
                    v-if="eleicao.intsituacao == 1"
                    class="btn-floating z-depth-0 btn-sm btn-primary"
                    data-tooltip-positions="top"
                    data-tooltip="Gerenciar Eleitores"
                    @click="usuariosVotantes(eleicao)"
                    data-toggle="modal"
                    data-target="#UsuariosEleicao"
                  >
                    <i class="fa fa-users" aria-hidden="true"></i>
                  </a>
                  &nbsp;
                  <a
                    v-if="eleicao.intsituacao == 1"
                    class="btn-floating z-depth-0 btn-sm btn-primary"
                    data-tooltip-positions="top"
                    data-tooltip="Gerenciar Candidatos"
                    @click="setCandidato(eleicao)"
                    data-toggle="modal"
                    data-target="#modalCandidatos"
                  >
                    <i class="fa fa-id-card" aria-hidden="true"></i>
                  </a>
                  &nbsp;
                  <a
                    v-if="eleicao.intsituacao == 1"
                    class="btn-floating z-depth-0 btn-sm btn-primary"
                    data-toggle="modal"
                    data-tooltip-positions="top"
                    data-tooltip="Editar Eleição"
                    data-target="#editarEleicao"
                    @click="editarEleicao(eleicao)"
                  >
                    <i class="fa fa-edit" aria-hidden="true"></i>
                  </a>
                  &nbsp;
                  <a
                    class="btn-floating z-depth-0 btn-sm btn-primary"
                    data-toggle="modal"
                    data-tooltip-positions="top"
                    data-tooltip="Detalhes da Eleição"
                    data-target="#modaldetalhes"
                    @click="showEleicao(eleicao)"
                  >
                    <i class="fa fa-info" aria-hidden="true"></i>
                  </a>
                  &nbsp;
                  <a
                    class="btn-floating z-depth-0 btn-sm btn-primary btn-success"
                    v-if="eleicao.intsituacao == 4"
                    data-toggle="modal"
                    data-tooltip-positions="top"
                    data-tooltip="Relatório de Eleitores"
                    data-target="#modalabstencao"
                    @click="showAbstencoes(eleicao)"
                  >
                    <i class="fas fa-file-pdf" aria-hidden="true"></i>
                  </a>

                  &nbsp;
                  <a
                    data-tooltip-positions="top"
                    data-tooltip="Finalizar Eleição"
                    v-if="eleicao.intsituacao != 1 && eleicao.intsituacao != 4"
                    class="btn-floating z-depth-0 btn-sm btn-danger"
                    @click.prevent="finalizaEleicao(eleicao)"
                  >
                    <i class="fa fa-stop" aria-hidden="true"></i>
                  </a>
                  &nbsp;
                  <a
                    data-tooltip-positions="top"
                    data-tooltip="Conferir frase-senha da urna"
                    v-if="eleicao.intsituacao == 3 && eleicao.boolurnaselada"
                    class="btn-floating z-depth-0 btn-sm btn-warning"
                    @click.prevent="verificaFrase(eleicao)"
                  >
                    <i class="fas fa-key" aria-hidden="true"></i>
                  </a>
                  &nbsp;
                  <a
                    data-tooltip-positions="top"
                    data-tooltip="Prorrogar horário final"
                    v-if="eleicao.intsituacao == 3 && eleicao.boolurnaselada"
                    class="btn-floating z-depth-0 btn-sm btn-warning"
                    @click.prevent="prorrogaEleicao(eleicao)"
                  >
                    <i class="fas fa-clock" aria-hidden="true"></i>
                  </a>
                  &nbsp;
                  <a
                    data-tooltip-positions="top"
                    data-tooltip="Zerésima (urna vazia no início)"
                    v-if="
                      (eleicao.intsituacao == 3 || eleicao.intsituacao == 4) &&
                      eleicao.boolurnaselada
                    "
                    class="btn-floating z-depth-0 btn-sm btn-default"
                    @click.prevent="showZeresima(eleicao)"
                  >
                    <i class="fas fa-clipboard-check" aria-hidden="true"></i>
                  </a>
                  &nbsp;
                  <a
                    data-tooltip-positions="top"
                    data-tooltip="E-mails de comprovante de comparecimento"
                    v-if="eleicao.intsituacao == 3 || eleicao.intsituacao == 4"
                    class="btn-floating z-depth-0 btn-sm btn-info"
                    @click.prevent="comprovantesEmail(eleicao)"
                  >
                    <i class="fas fa-envelope" aria-hidden="true"></i>
                  </a>
                  &nbsp;
                  <a
                    data-toggle="modal"
                    data-target="#modaljustificativa"
                    data-tooltip-positions="top"
                    data-tooltip="Justificar Desempate da Eleição"
                    v-if="
                      eleicao.intsituacao == 4 &&
                      eleicao.boolempate == true &&
                      eleicao.boolresultado == 0
                    "
                    class="btn-floating z-depth-0 btn-sm secondary-color-dark"
                    @click.prevent="showFormJustificativa(eleicao)"
                  >
                    <i class="fas fa-exclamation-triangle"></i>
                  </a>
                  &nbsp;
                  <a
                    data-tooltip-positions="top"
                    data-tooltip="Publicar Resultado da Eleição"
                    v-if="
                      eleicao.intsituacao == 4 && eleicao.boolresultado == 0
                    "
                    class="btn-floating z-depth-0 btn-sm btn-danger"
                    @click.prevent="publicarResultadoEleicao(eleicao)"
                  >
                    <i class="fas fa-eye"></i>
                  </a>
                  &nbsp;
                  <a
                    data-tooltip-positions="top"
                    data-tooltip="Iniciar Eleição"
                    v-if="eleicao.intsituacao == 1"
                    class="btn-floating z-depth-0 btn-sm btn-success"
                    @click.prevent="iniciaEleicao(eleicao)"
                  >
                    <i class="fas fa-play" aria-hidden="true"></i>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ModalDetalhes from "./ModalDetalhes";
import ModalAbstencoes from "./ModalAbstencoes";
import ModalEditarEleicoes from "./ModalEditarEleicoes";
import ModalCadastrarEleicoes from "./ModalCadastrarEleicoes";
import ModalCandidatos from "./../candidatos/Candidatos";
import ModalUsuariosEleicao from "./../usuarios/ModalUsuariosEleicao";
import ModalJustificativa from "./ModalJustificativa";
import ModalZeresima from "./ModalZeresima";

import Mixins from "../../mixins";
import Loading from "../misc/Loading";
import moment from "moment";
export default {
  components: {
    Loading,
    ModalDetalhes,
    ModalEditarEleicoes,
    ModalCadastrarEleicoes,
    ModalCandidatos,
    ModalUsuariosEleicao,
    ModalAbstencoes,
    ModalJustificativa,
    ModalZeresima,
  },
  mixins: [Mixins],
  data() {
    return {
      eleicaojustificativa: {},
      openJustificativa: false,
      eleicaoDetalhes: {},
      eleitoresAbstencao: {},
      eleicaoZeresima: {},
      openzeresima: false,
      eleicaoEditar: {},
      eleicoes: [],
      updComponentes: 0,
      opendetalhes: false,
      openusuarioeleicao: false,
      isLoading: true,
      openabstencoes: false,
    };
  },
  methods: {
    finalizaEleicao(eleicao) {
      // Urna selada: a apuração exige a frase-senha do titular OU do suplente.
      // Ver docs/manual-comissao-urna-selada.md
      swal
        .fire({
          title: "Finalizar e apurar",
          html: `<p style="text-align:left">Deseja finalizar a eleição <strong>${this.escaparHtml(eleicao.strdescricao)}</strong>?</p>
                 <p style="text-align:left; font-size:10pt">Informe a frase-senha do <strong>titular ou do suplente</strong> da comissão.
                 As cédulas serão abertas, embaralhadas e apuradas. Depois disso a urna cifrada e a chave são destruídas.</p>`,
          input: "password",
          inputPlaceholder: "Frase-senha da comissão",
          inputAttributes: {
            autocomplete: "off",
            autocapitalize: "off",
            spellcheck: "false",
          },
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "Finalizar e apurar",
          cancelButtonText: "Cancelar",
          reverseButtons: false,
          showLoaderOnConfirm: true,
          allowOutsideClick: () => !swal.isLoading(),
          inputValidator: (valor) =>
            !valor || !valor.trim() ? "Informe a frase-senha" : undefined,
          preConfirm: (frase) => {
            return axios
              .put(`/eleicoes/finalizar/${eleicao.streleicaouuid}`, {
                strfrase: frase,
              })
              .then((res) => res.data)
              .catch((err) => {
                swal.showValidationMessage(
                  (err.response &&
                    err.response.data &&
                    err.response.data.mensagem) ||
                    "Falha ao finalizar a eleição",
                );
              });
          },
        })
        .then((result) => {
          if (result.value) {
            toastr.success("Eleição finalizada e apurada com sucesso");
            this.getAllEleicoes();
          }
        });
    },
    async iniciaEleicao(eleicao) {
      // Lacre da urna: Presidente e Membro Titular da comissão digitam (cada um, sem que o
      // outro veja) uma frase-senha. As frases NÃO são gravadas: sem uma delas a
      // eleição não pode ser apurada.
      // O tamanho mínimo vem do servidor (URNA_FRASE_MIN), que também o confere.
      let minimo = 16;
      try {
        const cfg = await axios.get("/eleicoes/urna/configuracao");
        minimo = Number(cfg.data && cfg.data.frase_minima) || minimo;
      } catch (e) {
        /* mantém o padrão; o servidor valida de qualquer forma */
      }
      swal
        .fire({
          title: "Iniciar eleição e lacrar a urna",
          width: 700,
          html: `
            <p style="text-align:left">Eleição: <strong>${this.escaparHtml(eleicao.strdescricao)}</strong></p>
            <div class="alert alert-warning" style="text-align:left; font-size:10pt">
              <strong>Atenção:</strong> as frases-senha não ficam gravadas no sistema e <strong>não podem ser recuperadas</strong>.
              Sem a frase do titular ou do suplente <strong>a eleição não poderá ser apurada</strong>.
              Use pelo menos ${minimo} caracteres (recomendado: 5 palavras ou mais) e guarde em envelope lacrado.
            </div>
            <div style="text-align:left">
              <label for="frase-titular"><strong>Titular</strong> — frase-senha</label>
              <input id="frase-titular" type="password" class="swal2-input" autocomplete="off" style="margin:4px 0 8px 0">
              <label for="frase-titular2">Titular — repita a frase-senha</label>
              <input id="frase-titular2" type="password" class="swal2-input" autocomplete="off" style="margin:4px 0 16px 0">
              <label for="frase-suplente"><strong>Suplente</strong> — frase-senha</label>
              <input id="frase-suplente" type="password" class="swal2-input" autocomplete="off" style="margin:4px 0 8px 0">
              <label for="frase-suplente2">Suplente — repita a frase-senha</label>
              <input id="frase-suplente2" type="password" class="swal2-input" autocomplete="off" style="margin:4px 0 0 0">
            </div>`,
          type: "warning",
          focusConfirm: false,
          showCancelButton: true,
          confirmButtonText: "Iniciar e lacrar",
          cancelButtonText: "Cancelar",
          reverseButtons: false,
          showLoaderOnConfirm: true,
          allowOutsideClick: () => !swal.isLoading(),
          preConfirm: () => {
            const v = (id) => document.getElementById(id).value;
            const t = v("frase-titular"),
              t2 = v("frase-titular2"),
              s = v("frase-suplente"),
              s2 = v("frase-suplente2");
            if (t.trim().length < minimo)
              return swal.showValidationMessage(
                `A frase do titular deve ter pelo menos ${minimo} caracteres`,
              );
            if (t !== t2)
              return swal.showValidationMessage(
                "A repetição da frase do titular não confere",
              );
            if (s.trim().length < minimo)
              return swal.showValidationMessage(
                `A frase do suplente deve ter pelo menos ${minimo} caracteres`,
              );
            if (s !== s2)
              return swal.showValidationMessage(
                "A repetição da frase do suplente não confere",
              );
            if (t.trim() === s.trim())
              return swal.showValidationMessage(
                "Titular e suplente devem usar frases diferentes",
              );
            return axios
              .put(`/eleicoes/iniciar/${eleicao.streleicaouuid}`, {
                strfrasetitular: t,
                strfrasesuplente: s,
              })
              .then((res) => res.data)
              .catch((err) => {
                swal.showValidationMessage(
                  (err.response &&
                    err.response.data &&
                    err.response.data.mensagem) ||
                    "Falha ao iniciar a eleição",
                );
              });
          },
        })
        .then((result) => {
          if (result.value) {
            this.getAllEleicoes();
            swal.fire({
              title: "Eleição iniciada e urna lacrada",
              type: "success",
              html: `<p>Registre em ata a <strong>impressão digital da urna</strong>:</p>
                         <p style="font-family:monospace; font-size:13pt"><strong>${this.escaparHtml(result.value.impressaodigital || "")}</strong></p>
                         ${result.value.auditoria ? `<p style="font-size:10pt">Registro de auditoria nº <strong>${Number(result.value.auditoria.id)}</strong></p>` : ""}
                         ${result.value.zeresima ? `<p style="font-size:10pt">Zerésima registrada (urna vazia) — nº <strong>${Number(result.value.zeresima.id)}</strong>. Emita pelo botão <i class="fas fa-clipboard-check"></i> <em>Zerésima</em>.</p>` : ""}
                         <p style="font-size:10pt; text-align:left">Recomendado: agora, titular e suplente usam o botão
                         <i class="fas fa-key"></i> <em>Conferir frase-senha</em> para confirmar que suas frases funcionam.</p>`,
            });
          }
        });
    },
    /** Zerésima: abre o relatório de urna vazia registrado no início. */
    showZeresima(eleicao) {
      this.eleicaoZeresima = Object.assign({}, eleicao);
      this.openzeresima = true;
      this.forceUpdate();
      this.$nextTick(() => $("#modalzeresima").modal("show"));
    },
    /** Prorroga o horário final (só para mais tarde, com justificativa; fica na auditoria). */
    async prorrogaEleicao(eleicao) {
      const doisDig = (n) => String(n).padStart(2, "0");
      const local = (d) =>
        `${d.getFullYear()}-${doisDig(d.getMonth() + 1)}-${doisDig(d.getDate())}T${doisDig(d.getHours())}:${doisDig(d.getMinutes())}`;
      const atual = new Date(eleicao.dtafinal);
      const sugestao = new Date(
        Math.max(atual.getTime(), Date.now()) + 60 * 60 * 1000,
      );
      const encerrada = Date.now() >= atual.getTime();
      const result = await swal.fire({
        title: "Prorrogar horário final",
        width: 650,
        html: `
          <p style="text-align:left">Eleição: <strong>${this.escaparHtml(eleicao.strdescricao)}</strong></p>
          <p style="text-align:left">Término atual: <strong>${this.escaparHtml(this.$options.filters.dateFull_br(eleicao.dtafinal))}</strong>
            ${encerrada ? '<br/><span style="color:#c00">A votação já está encerrada; a prorrogação a reabre até o novo horário.</span>' : ""}</p>
          <div style="text-align:left">
            <label for="prorroga-data"><strong>Novo horário final</strong></label>
            <input id="prorroga-data" type="datetime-local" class="swal2-input" value="${local(sugestao)}" style="margin:4px 0 12px 0">
            <label for="prorroga-justificativa"><strong>Justificativa</strong> (obrigatória; fica registrada na auditoria)</label>
            <textarea id="prorroga-justificativa" class="swal2-textarea" maxlength="2000" style="margin:4px 0 0 0"></textarea>
          </div>
          <p style="text-align:left; font-size:9pt" class="mt-2">Só é possível prorrogar para <strong>mais tarde</strong>. A eleição continua precisando ser
          finalizada pela comissão (com a frase-senha) depois do novo horário.</p>`,
        type: "question",
        focusConfirm: false,
        showCancelButton: true,
        confirmButtonText: "Prorrogar",
        cancelButtonText: "Cancelar",
        showLoaderOnConfirm: true,
        allowOutsideClick: () => !swal.isLoading(),
        preConfirm: () => {
          const valor = document.getElementById("prorroga-data").value;
          const justificativa = document
            .getElementById("prorroga-justificativa")
            .value.trim();
          const novo = new Date(valor);
          if (!valor || isNaN(novo.getTime()))
            return swal.showValidationMessage("Informe o novo horário final");
          if (novo.getTime() <= atual.getTime())
            return swal.showValidationMessage(
              "O novo horário deve ser posterior ao término atual",
            );
          if (justificativa.length < 10)
            return swal.showValidationMessage(
              "Informe a justificativa (mínimo 10 caracteres)",
            );
          return axios
            .put(`/eleicoes/prorrogar/${eleicao.streleicaouuid}`, {
              dtafinal: novo.toISOString(),
              strjustificativa: justificativa,
            })
            .then((res) => res.data)
            .catch((err) =>
              swal.showValidationMessage(
                (err.response &&
                  err.response.data &&
                  err.response.data.mensagem) ||
                  "Falha ao prorrogar",
              ),
            );
        },
      });
      if (result.value) {
        toastr.success(result.value.mensagem || "Eleição prorrogada");
        this.getAllEleicoes();
      }
    },
    verificaFrase(eleicao) {
      // Ensaio: confere se uma frase-senha abre a urna, SEM finalizar a eleição.
      swal
        .fire({
          title: "Conferir frase-senha",
          text: "Digite a frase-senha do titular ou do suplente. A eleição NÃO será finalizada.",
          input: "password",
          inputPlaceholder: "Frase-senha",
          inputAttributes: {
            autocomplete: "off",
            autocapitalize: "off",
            spellcheck: "false",
          },
          showCancelButton: true,
          confirmButtonText: "Conferir",
          cancelButtonText: "Cancelar",
          showLoaderOnConfirm: true,
          allowOutsideClick: () => !swal.isLoading(),
          inputValidator: (valor) =>
            !valor || !valor.trim() ? "Informe a frase-senha" : undefined,
          preConfirm: (frase) => {
            return axios
              .put(`/eleicoes/urna/verificar/${eleicao.streleicaouuid}`, {
                strfrase: frase,
              })
              .then((res) => res.data)
              .catch((err) => {
                swal.showValidationMessage(
                  (err.response &&
                    err.response.data &&
                    err.response.data.mensagem) ||
                    "Falha ao conferir",
                );
              });
          },
        })
        .then((result) => {
          if (result.value) {
            swal.fire({
              title: "Frase-senha confere",
              type: "success",
              html: `<p>Frase do <strong>${this.escaparHtml(result.value.papel)}</strong>.</p>
                         <p>Impressão digital da urna:<br><span style="font-family:monospace"><strong>${this.escaparHtml(result.value.impressaodigital)}</strong></span></p>`,
            });
          }
        });
    },
    comprovantesEmail(eleicao) {
      // Etapa C: situação dos e-mails de comprovante de COMPARECIMENTO e reenvio em lote
      const rotulos = {
        enviado: "Enviados",
        falha: "Com falha",
        pendente: "Em envio",
        sem_email: "Eleitor sem e-mail",
        anterior: "Antes desta versão",
      };
      axios.get(`/eleicoes/comprovantes/${eleicao.id}`).then(
        (res) => {
          const d = res.data;
          const linhas = d.situacao
            .map(
              (s) =>
                `<tr><td style="text-align:left">${this.escaparHtml(rotulos[s.situacao] || s.situacao)}</td><td><strong>${s.total}</strong></td></tr>`,
            )
            .join("");
          const pend = d.pendentes
            .slice(0, 50)
            .map(
              (p) =>
                `<li>${this.escaparHtml(p.strnome || p.strusuario)}${p.possuiemail ? "" : " <em>(sem e-mail cadastrado)</em>"}</li>`,
            )
            .join("");
          swal
            .fire({
              title: "Comprovantes de comparecimento",
              width: 650,
              html: `<p style="text-align:left">${this.escaparHtml(eleicao.strdescricao)}</p>
                       <table class="table table-sm"><tbody>${linhas || "<tr><td>Nenhum comparecimento</td></tr>"}</tbody></table>
                       ${d.pendentes.length ? `<p style="text-align:left"><strong>Pendentes (${d.pendentes.length}):</strong></p><ul style="text-align:left; max-height:180px; overflow:auto">${pend}</ul>` : ""}`,
              showCancelButton: d.pendentes.length > 0,
              showConfirmButton: true,
              confirmButtonText: d.pendentes.length
                ? "Reenviar pendentes"
                : "Fechar",
              cancelButtonText: "Fechar",
            })
            .then((r) => {
              if (r.value && d.pendentes.length) {
                axios
                  .post(`/eleicoes/comprovantes/reenviar/${eleicao.id}`, {})
                  .then(
                    (res2) => toastr.success(res2.data.mensagem),
                    (err) =>
                      toastr.error(
                        (err.response &&
                          err.response.data &&
                          err.response.data.mensagem) ||
                          "Falha ao reenviar",
                      ),
                  );
              }
            });
        },
        (err) => {
          toastr.error(
            (err.response && err.response.data && err.response.data.mensagem) ||
              "Falha ao consultar os comprovantes",
          );
        },
      );
    },
    escaparHtml(texto) {
      return String(texto == null ? "" : texto).replace(
        /[&<>"']/g,
        (c) =>
          ({
            "&": "&amp;",
            "<": "&lt;",
            ">": "&gt;",
            '"': "&quot;",
            "'": "&#39;",
          })[c],
      );
    },
    usuariosVotantes(eleicao) {
      this.eleicaoDetalhes = { ...eleicao };
      this.openusuarioeleicao = true;
      this.forceUpdate();
    },
    setCandidato(eleicao) {
      this.forceUpdate();
      Object.assign(this.eleicaoDetalhes, eleicao);
    },
    newEleicao() {
      this.forceUpdate();
    },
    forceUpdate() {
      this.updComponentes += 1;
    },
    async getAllEleicoes() {
      await axios
        .get("/eleicoes/listar")
        .then((res) => {
          this.eleicoes = res.data.eleicoes;
          this.isLoading = false;
        })
        .catch((err) => {
          console.log("erro inesperado");
        });
    },
    showEleicao(eleicao) {
      Object.assign(this.eleicaoDetalhes, eleicao);
      this.opendetalhes = true;
      this.forceUpdate();
    },
    showAbstencoes(eleicao) {
      this.openabstencoes = true;
      Object.assign(this.eleitoresAbstencao, eleicao);
      this.forceUpdate();
    },
    showFormJustificativa(eleicao) {
      this.openJustificativa = true;
      Object.assign(this.eleicaojustificativa, eleicao);
      this.forceUpdate();
    },
    editarEleicao(eleicao) {
      Object.assign(this.eleicaoEditar, eleicao);

      this.forceUpdate();
    },
    publicarResultadoEleicao(eleicao) {
      swal
        .fire({
          title: "Atenção",
          text: "Deseja publicar o resultado da eleição ?",
          type: "question",
          showCancelButton: true,
          confirmButtonText: "Sim",
          cancelButtonText: "Não",
          reverseButtons: false,
        })
        .then((result) => {
          if (result.value) {
            axios
              .put(`/eleicoes/publicar/${eleicao.streleicaouuid}`, eleicao)
              .then(
                (res) => {
                  toastr.success("Resultado Publicado");
                  this.getAllEleicoes();
                },
                (err) => {
                  if (err.response.data.mensagem)
                    toastr.error(err.response.data.mensagem);
                },
              );
          }
        });
    },
  },
  mounted() {
    this.getAllEleicoes();
  },
};
</script>
